<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
	<div class="sidebar-next-right-block">
		<div class="partner-right-block-body">
			<div class="settings-partnership-header-label">Partnership Terms</div>

			<div class="flex flex-row" style="grid-gap: 150px;">
				<div>
					<div class="settings-partnership-label">Xpress Services</div>
					<div class="flex flex-row settings-partnership-item">
						<div class="settings-partnership-item-label">Services:</div>
						<div class="settings-partnership-item-value"><div style="margin-right: 10px;">{{merchantInfo.MerchantServiceTypesList.join(', ')}}</div></div>
					</div>
					<div class="flex flex-row settings-partnership-item" *ngIf="merchantInfo.Categories.length !== 0">
						<div class="settings-partnership-item-label">Category:</div>
						<div class="settings-partnership-item-value">{{merchantInfo.Categories.join(', ')}}</div>
					</div>

					<div class="settings-partnership-label">Partnership Agreement with Xpress</div>
					<div class="flex flex-row settings-partnership-item">
						<div class="settings-partnership-item-label">Agreement:</div>
						<div>
							<div class="settings-partnership-item-value">All orders processed through the Xpress platform:</div>
							<div class="settings-partnership-item-label" *ngIf="merchantInfo.UsePercentServiceFeeStr">{{merchantInfo.UsePercentServiceFeeStr}} %</div>
							<div class="settings-partnership-item-label" *ngIf="merchantInfo.UseAmountServiceFeeStr">{{merchantInfo.UseAmountServiceFeeStr}} &#8369;</div>
						</div>
					</div>
					<!--<div class="flex flex-row settings-partnership-item">
					<div class="settings-partnership-item-label">Additional:</div>
					<div>
						<div class="settings-partnership-item-value">Promo:</div>
						<div>First 30 days at 5% + VAT for all services</div>
					</div>
				</div>-->

					<div class="settings-partnership-label">Effectivity Dates:</div>
					<div class="flex flex-row settings-partnership-item">
						<div class="settings-partnership-item-label">Signing date:</div>
						<div class="settings-partnership-item-value">{{merchantInfo.SubmittedAt}}</div>
					</div>
					<div class="flex flex-row settings-partnership-item">
						<div class="settings-partnership-item-label">Effective:</div>
						<div class="settings-partnership-item-value">{{merchantInfo.DateActivatedAt}}</div>
					</div>
					<div class="flex flex-row settings-partnership-item">
						<div class="settings-partnership-item-label">Period:</div>
						<div class="settings-partnership-item-value">{{merchantInfo.PeriodStr}}</div>
					</div>
					<div class="flex flex-row settings-partnership-item">
						<div class="settings-partnership-item-label">Store Activation:</div>
						<div class="settings-partnership-item-value">{{merchantInfo.StoreActivationStr}}</div>
					</div>
				</div>

				<div>
					<div class="flex flex-row">
						<div class="settings-partnership-label">Partnership Agreement:</div>
						<div class="settings-partnership-label" style="margin-left: auto">
							<p-button icon="pi pi-print" styleClass="p-button-rounded p-button-text"></p-button>
						</div>

					</div>


					<div class="settings-partnership-document"></div>
				</div>
			</div>
		</div>
		<p-toast position="top-right"></p-toast>
	</div>
</div>
